<template>
  <section>
    <div class="page">
      <div>
        <h2>
          Checking Read Receipts
        </h2>
        <p>
          Check marks will appear next to each message you send. Here's what
          check mark indicates:
        </p>
        <ul>
          <li>
            <strong>The Gray Check Marks</strong> →Message successfully sent.
          </li>
          <li>
            <strong>Two Gray Check Marks</strong> →Message successfully
            delivered to the recipient's phone.
          </li>
          <li>
            <strong>Two Green Check Marks</strong> →The recipient has read your
            message.
          </li>
        </ul>
        <h3>
          Missing Read Receipts
        </h3>
        <p>
          If you don't see two green check marks next to your sent message,
          there could be several reasons:
        </p>
        <ul>
          <li>
            You or your recipient might've disabled read receipts in the privacy
            settings.
          </li>
          <li>
            The recipient might've blocked you.
          </li>
          <li>
            The recipient's phone might be off.
          </li>
          <li>
            The recipient might not have opened your conversation.
          </li>
          <li>
            You or the recipient might be experiencing connection issues.
          </li>
        </ul>
        <h3>
          Turning off Read Receipts
        </h3>
        <p>
          To turn off your read receipts, tap <strong>Me</strong> >
          <strong>Chats</strong> and turn off Read receipts.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
